const relativeTime = {
  now: "сейчас",
  inMinutes: "через {n} мин",
  inHours: "через {n} ч",
} as const;
export default relativeTime;
